export default "__VITE_ASSET__BB_px4qq__"